import React from "react";
import "./StyleComponents/HomePresentation.css";

const HomePresentation = () => {
    return (
        <div className="Intro" id='home'>
            <div className="IntroInner">
                <h1 className="HeroTitle" aria-label="To the most angelic, beautiful, and delightfully bubbly princess ever">
                    <span className="HeroLine1">To the most angelic, beautiful,</span>
                    <span className="HeroLine2">and delightfully bubbly princess ever 🤍</span>
                </h1>
            </div>
        </div>
    );
};

export default HomePresentation;
